module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av569-b68f02d138af4c4be2949088a635a03e.jpg";